import { ListDefinition } from "./listDefinition.types";
import { registerFieldComponents } from "../config/fieldComponents";
import { abtestsListDefinition } from "./abtestsListDefinition";
import { accountsListDefinition } from "./accountsListDefinition";
import { automationListListDefinition } from "./automationListListDefinition";
import { communicationsListDefinition } from "./communicationsListDefinition";
import { listFieldComponents } from "./listFieldComponents";
import { campaignsListDefinition } from "./campaignsListDefinition";
import { communicationActivitiesListDefinition } from "./communicationActivitiesListDefinition";
import { communicationAudiencesListDefinition } from "./communicationAudiencesListDefinition";
import { competitionsListDefinition } from "./competitionsListDefinition";
import { competitionStagesListDefinition } from "./competitionStagesListDefinition";
import { contactsListDefinition } from "./contactsListDefinition";
import { dataImportsListDefinition } from "./dataImportsListDefinition";
import { dataModelsListDefinition } from "./dataModelsListDefinition";
import { entityAuditsListDefinition } from "./entityAuditsListDefinition";
import { eventProfilesListDefinition } from "./eventProfilesListDefinition";
import { fixturesListDefinition } from "./fixturesListDefinition";
import { fixtureGradesListDefinition } from "./fixtureGradesListDefinition";
import { opponentsListDefinition } from "./opponentsListDefinition";
import { opponentTypesListDefinition } from "./opponentTypesListDefinition";
import { seasonalPeriodsListDefinition } from "./seasonalPeriodsListDefinition";
import { seasonsListDefinition } from "./seasonsListDefinition";
import { marketingListsListDefinition } from "./marketingListsListDefinition";
import { subscriptionGroupsListDefinition } from "./subscriptionGroupsListDefinition";
import { teamsListDefinition } from "./teamsListDefinition";
import { ticketHospitalityProductsListDefinition } from "./ticketHospitalityProductsListDefinition";
import { typesListDefinition } from "./typesListDefinition";
import { venueStatusesListDefinition } from "./venueStatusesListDefinition";

/**
 * Every list page the page components serve. Adding a list is an entry here plus its
 * columns - no per-page components, the same promise `recordDefinitions` makes for
 * record pages.
 */
export const listDefinitions: ListDefinition[] = [
  abtestsListDefinition,
  accountsListDefinition,
  automationListListDefinition,
  communicationsListDefinition,
  campaignsListDefinition,
  communicationActivitiesListDefinition,
  communicationAudiencesListDefinition,
  competitionsListDefinition,
  competitionStagesListDefinition,
  contactsListDefinition,
  dataImportsListDefinition,
  dataModelsListDefinition,
  entityAuditsListDefinition,
  eventProfilesListDefinition,
  fixturesListDefinition,
  fixtureGradesListDefinition,
  marketingListsListDefinition,
  opponentsListDefinition,
  opponentTypesListDefinition,
  seasonalPeriodsListDefinition,
  seasonsListDefinition,
  subscriptionGroupsListDefinition,
  teamsListDefinition,
  ticketHospitalityProductsListDefinition,
  typesListDefinition,
  venueStatusesListDefinition,
];

// The cells these lists draw by name, for lists with no record definition to carry them.
registerFieldComponents(listFieldComponents);

const byPath = new Map(
  listDefinitions.map((definition) => [definition.path, definition])
);

export function getListDefinition(path: string) {
  return byPath.get(path);
}
